module.exports = __webpack_public_path__ + "img/25.447f14a9.jpg";